import { resolveRomaBranchCopy, type RomaBranch } from "@/lib/roma-branch";

export type EventVenue = {
  name: string;
  addressLine1: string;
  addressLine2: string;
  phoneDisplay: string;
  phoneHref: string;
  mapsUrl: string;
};

/**
 * Picks the address/phone/maps block to render on a public event page: the
 * Roma dining room's own copy when the event carries a `romaBranch`, or the
 * tenant's existing fallback (Tuscan Cove or Roma's default) otherwise.
 */
export function resolveEventVenue({
  romaBranch,
  locationId,
  fallback,
}: {
  romaBranch: RomaBranch | undefined;
  locationId: string | undefined;
  fallback: EventVenue;
}): EventVenue {
  if (!locationId?.startsWith("roma-kitchen-")) return fallback;
  const copy = resolveRomaBranchCopy(romaBranch);
  if (!copy) return fallback;
  return {
    name: copy.shortName,
    addressLine1: copy.addressLine1,
    addressLine2: copy.addressLine2,
    phoneDisplay: copy.phoneDisplay,
    phoneHref: copy.phoneHref,
    mapsUrl: copy.mapsUrl,
  };
}
